import React, { Component } from 'react';

import api from '../../api/api';
import Modal from "./Modal"

import ParadigmaTable from '../../components/ParadigmaTable/ParadigmaTable';


class Tutoriales extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: "nombre",
                    show: true,
                },
            ]
        };
    }

    render() {
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'tutoriales_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'tutoriales_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'tutoriales_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'tutoriales_delete',
                    }
                ]}
                apiUrl={api.tutoriales.list}
                columns={this.state.columns}
                exportUrl={null}
                title={"Tutoriales"}
            />
        );
    }
}

export default Tutoriales;



// WEBPACK FOOTER //
// ./src/views/Tutoriales/Tutoriales.js